export class MsUtils {
  /**
   * Gets a GUID like copied from the interwebz :)
   */
  static uuidv4 () {
    // for IE 11
    var cryptoObj = window.crypto || window.msCrypto

    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
  }
}
